/**
 * Appends a width transform to Cloudflare Images avatar URLs.
 * Non-Cloudflare URLs (Google, etc.) are returned as-is.
 */
export function avatarUrl(src: string | undefined | null, sizePx: number): string | undefined {
  if (!src) return undefined
  if (!src.includes("imagedelivery.net")) return src

  const lastSlash = src.lastIndexOf("/")
  if (lastSlash === -1) return src

  const base = src.slice(0, lastSlash)
  return `${base}/width=${sizePx * 2},fit=cover`
}
